import { combineReducers } from "redux";

import authReducer from "./auth";
import rmqReducer from "./rmq";
import dashboardReducer from "./dashboard";

export default combineReducers({
  authReducer,
  rmqReducer,
  dashboardReducer,
});
